<div class="header">
    <!-- <div class="header-search">
      <label for="Search..."></label>
      <input type="search" placeholder="Search...">
    </div>
    <div class="header-profile"><img src="assets/images/profile.png" alt="">
      <p>Ashley</p>
    </div> -->
  </div>